module.exports = __webpack_public_path__ + "img/google-chat.ecaf0719.svg";